import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshing = null;
const NO_RETRY = ["/auth/login", "/auth/refresh", "/auth/logout"];

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    const url = original.url || "";
    if (error.response?.status === 401 && !original._retry && !NO_RETRY.some((u) => url.includes(u))) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
        window.dispatchEvent(new Event("auth:expired"));
      }
    }
    return Promise.reject(error);
  }
);

const FIELD_LABELS = {
  landCode: "Kode Lahan", projectCode: "Kode Kebun", name: "Nama", province: "Provinsi", regency: "Kabupaten/Kota", district: "Kecamatan",
  village: "Nagari/Desa", areaHectares: "Luas lahan", effectiveAreaHectares: "Luas efektif", ownerName: "Nama pemilik lahan",
  ownerPhone: "Kontak pemilik", phone: "Nomor telepon", email: "Email", latitude: "Latitude", longitude: "Longitude",
  boundary: "Batas lahan", exclusions: "Area tidak ditanami", elevation: "Ketinggian", capacityOverride: "Jumlah batang aktual",
  fullName: "Nama lengkap", ownerAddress: "Alamat pemilik", landName: "Nama lahan", landAddress: "Alamat lahan", whatsapp: "WhatsApp",
  ownerShare: "Porsi Pemilik Lahan", managerShare: "Porsi Pengelola", investorShare: "Porsi Pemodal Kebun", platformFee: "Imbalan Jasa PT SJI", termYears: "Jangka waktu", managerName: "Nama pengelola",
};
const friendly = (e) => {
  const loc = (e.loc || []).filter((x) => typeof x === "string" && x !== "body");
  const label = FIELD_LABELS[loc[0]] || "Isian";
  const t = e.type || "";
  if (t === "value_error") return e.msg.replace(/^Value error, /, "");
  if (t === "missing") return `${label} wajib diisi.`;
  if (t === "string_pattern_mismatch") return `${label} berisi karakter yang tidak diizinkan.`;
  if (t === "string_too_short") return `${label} terlalu pendek.`;
  if (t === "string_too_long" || t === "too_long") return `${label} terlalu panjang.`;
  if (t === "extra_forbidden") return "Ada data yang tidak dikenal. Muat ulang halaman lalu coba lagi.";
  return `${label} tidak valid.`;
};

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return [...new Set(detail.map((e) => (e && typeof e === "object" ? friendly(e) : "Data tidak valid.")))].join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
